import * as firebase from 'firebase/app';
import 'firebase/firestore';
import {
  WORKOUT_NAME_MUST_BE_UNIQUE,
  SERIES_NAME_MUST_BE_UNIQUE
} from 'utils/constants/errors';
import { USER_NOT_SIGNED_IN_ERROR_MSG, EXERCISE_UNIQUENESS_ERROR } from 'utils/constants/errors';
import { workoutsLevels } from 'utils/constants/selectFieldsOptions';
import { WORKOUTS, REPS, EXERCISES, CLIENTS, DETAILS } from 'utils/constants/collectionNames';
import { CUSTOM_REP, METHOD } from 'utils/constants/workouts';
import { checkUniqueness } from 'api/helpers/checkUniqueness.js';
import {
  GET_WORKOUTS_SUCCEED,
  GET_WORKOUTS_ERROR,
  CREATE_WORKOUT_SUCCEED,
  CREATE_WORKOUT_ERROR,
  WORKOUT_UNIQUENESS_CHECK_ERROR,
  RESET_WORKOUT_UNIQUENESS_ERROR,
  GET_WORKOUT_SUCCEED,
  GET_WORKOUT_ERROR,
  DELETE_WORKOUT_SUCCEED,
  DELETE_WORKOUT_ERROR,
  UNASSIGN_CLIENT_SUCCEED,
  UNASSIGN_CLIENT_ERROR,
  ASSIGN_CLIENTS_SUCCEED,
  ASSIGN_CLIENTS_ERROR,
  RENAME_WORKOUT_SUCCEED,
  RENAME_WORKOUT_ERROR,
  GET_TRAINER_EXERCIES_SUCCEED,
  GET_TRAINER_EXERCIES_ERROR,
  GET_REPS_SUCCEED,
  GET_REPS_ERROR,
  CREATE_SERIES_SUCCEED,
  CREATE_SERIES_ERROR,
  CREATE_SERIES_UNIQUENESS_ERROR,
  GET_SERIES_BY_ID_SUCCEED,
  GET_SERIES_BY_ID_ERROR,
  DELETE_SERIES_ERROR,
  EDIT_SERIES_SUCCEED,
  EDIT_SERIES_ERROR,
  EXERCISE_UNIQUENESS_CHECK_ERROR,
  CREATE_EXERCISE_SUCCEED,
  CREATE_EXERCISE_ERROR,
  RESET_EXERCISE_MODEL,
  GET_CLIENT_WORKOUT_SUCCEEDED,
  GET_CLIENT_WORKOUT_ERROR,
  ASSIGN_CLIENT_TO_WORKOUTS_SUCCEEDED,
  ASSIGN_CLIENT_TO_WORKOUTS_ERROR,
  LOADING_STATE,
  SUBMITTIG_LOADING_STATE,
  UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED,
  UPDATE_CLIENT_WORKOUTS_ORDER_ERROR,
  SERIES_LOADING_STATE,
  UPDATE_SERIES_ORDER_SUCCEED,
  UPDATE_SERIES_ORDER_ERROR
} from './types';

export const getWorkouts = trainerId => async dispatch => {
  try {
    dispatch({ type: LOADING_STATE });
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(WORKOUTS)
      .where('trainer_id', '==', trainerId);
    return queryRef.onSnapshot(querySnapshot => {
      const workouts =
        querySnapshot.docs &&
        querySnapshot.docs.map(doc => {
          return {
            ...doc.data(),
            id: doc.id
          };
        });
      // sorting workouts by level then phase then name
      workouts.sort((workout1, workout2) => {
        return (
          workoutsLevels.findIndex(
            workoutLevel => workoutLevel === workout1.level
          ) -
            workoutsLevels.findIndex(
              workoutLevel => workoutLevel === workout2.level
            ) ||
          workout1.phase - workout2.phase ||
          (workout1.name > workout2.name ? 1 : -1)
        );
      });

      dispatch({ type: GET_WORKOUTS_SUCCEED, payload: workouts });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_WORKOUTS_ERROR,
      payload: `error: ${err}`
    });
  }
};

export const createWorkout = (workout, history) => async dispatch => {
  var trainer = await firebase.auth().currentUser;

  //checkNameUniqueness = (value, collection, field)
  return checkUniqueness(workout.name, WORKOUTS, 'name')
    .then(isUnique => {
      if (isUnique) {
        let newWorkout = {
          ...workout,
          created_at: new Date(),
          trainer_id: trainer.uid,
          clients_id: []
        };
        dispatch({ type: LOADING_STATE });
        let firestore = firebase.firestore();
        return firestore
          .collection(WORKOUTS)
          .add({ ...newWorkout })
          .then(function(docRef) {
            dispatch({
              type: CREATE_WORKOUT_SUCCEED,
              payload: docRef.id
            });
            history.push(`/workouts/${docRef.id}`);
          })
          .catch(function(error) {
            console.error('Error adding document: ', error);
            dispatch({
              type: CREATE_WORKOUT_ERROR,
              payload: `error: ${error}`
            });
          });
      } else {
        dispatch({
          type: WORKOUT_UNIQUENESS_CHECK_ERROR,
          payload: WORKOUT_NAME_MUST_BE_UNIQUE
        });
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: CREATE_WORKOUT_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const resetUniquenessError = () => async dispatch => {
  dispatch({ type: RESET_WORKOUT_UNIQUENESS_ERROR });
};

export const getWorkout = (workoutId, history) => async dispatch => {
  let firestore = firebase.firestore();
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      dispatch({ type: LOADING_STATE });
      let docRef = firestore.collection(WORKOUTS).doc(workoutId);
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists && user.uid === doc.data().trainer_id) {
            getSeries({ ...doc.data(), id: doc.id }, dispatch);
          } else {
            console.log('This Workout is not exist!');
            history.replace('/event-not-found');
          }
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: GET_WORKOUT_ERROR,
            payload: `error: ${error}`
          });
          history.replace('/event-not-found');
        });
    } else {
      dispatch({
        type: GET_WORKOUT_ERROR,
        payload: `error: ${USER_NOT_SIGNED_IN_ERROR_MSG}`
      });
    }
  });
};

const getSeries = (workout, dispatch) => {
  let firestore = firebase.firestore();
  firestore
    .collection(`workouts/${workout.id}/workout_series`)
    .orderBy('name', 'asc')
    .get()
    .then(querySnapshot => {
      const series =
        querySnapshot.docs &&
        querySnapshot.docs.map(seriesDoc => {
          return { ...seriesDoc.data(), id: seriesDoc.id };
        });

      series.sort((series1, series2) => {
        return (
          (series1.name > series2.name ? 1 : -1)
        );
      });

      dispatch({
        type: GET_WORKOUT_SUCCEED,
        payload: { ...workout, series: series }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_WORKOUT_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const deleteWorkout = workoutId => async dispatch => {
  let db = firebase.firestore();
  db.collection(WORKOUTS)
    .doc(workoutId)
    .delete()
    .then(function() {
      dispatch({ type: DELETE_WORKOUT_SUCCEED });
      console.log('Document successfully deleted!');
    })
    .catch(function(error) {
      console.error('Error removing document: ', error);
      dispatch({
        type: DELETE_WORKOUT_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const unassignClient = (clientId, workoutId) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(WORKOUTS).doc(workoutId);

  updateClientOrder(clientId, workoutId, dispatch);
  return docRef
    .update({
      clients_id: firebase.firestore.FieldValue.arrayRemove(clientId),
      [`clients_data.${clientId}`]: firebase.firestore.FieldValue.delete()
      })
    .then(() => {
      return docRef.get().then(doc => {
        dispatch({
          type: UNASSIGN_CLIENT_SUCCEED,
          payload: { ...doc.data(), id: workoutId }
        });
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: UNASSIGN_CLIENT_ERROR,
        payload: `error: ${error}`
      });
    });
};

const updateClientOrder = (clientId, workoutId, dispatch) => {
  let firestore = firebase.firestore();

  firestore
    .collection(CLIENTS)
    .doc(clientId)
    .collection(DETAILS)
    .doc('workout-order')
    .get()
    .then(doc => {
      let clientOrder = doc.data() ? doc.data().order : {};
      if (Object.keys(clientOrder).length) {
        delete clientOrder[workoutId]
        setNewClientOrder(clientId, clientOrder, dispatch);
      }
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: UNASSIGN_CLIENT_ERROR,
        payload: `error: ${error}`
      });
    });
}

export const updateSeriesOrder = (workoutId, seriesOrder) => async dispatch => {
  let firestore = firebase.firestore();

  firestore
    .collection(WORKOUTS)
    .doc(workoutId)
    .set({
      series_order: { ...seriesOrder }
    }, { merge: true })
    .then(response => {
      dispatch({ type: UPDATE_SERIES_ORDER_SUCCEED });
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: UPDATE_SERIES_ORDER_ERROR,
        payload: `error: ${error}`
      });
    });
}

const setNewClientOrder = (clientId, clientOrder, dispatch) => {
  let firestore = firebase.firestore();

  firestore
    .collection(CLIENTS)
    .doc(clientId)
    .collection(DETAILS)
    .doc('workout-order')
    .set({
      order: { ...clientOrder }
    })
    .then(response => {
      console.log('update is done');
      dispatch({ type: UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED });
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: UPDATE_CLIENT_WORKOUTS_ORDER_ERROR,
        payload: `error: ${error}`
      });
    });
}


export const assignWorkoutToClients = (
  clients,
  workoutId,
  history
) => async dispatch => {
  let firestore = firebase.firestore();
  const assignDate = new Date();

  var docRef = firestore.collection(WORKOUTS).doc(workoutId);
  var clientsId = [];
  var clientsData = {};
  clients.forEach(client => {
    clientsId.push(client.id);
    clientsData = {
      ...clientsData,
      [`${client.id}`]: {
        assigned_at: assignDate,
        photo_url: client.photo || '',
        display_name: `${client.first_name} ${client.last_name}`
      }
    };
  });

  return docRef
  .set(
      {
        clients_id: firebase.firestore.FieldValue.arrayUnion(...clientsId),
        clients_data: clientsData
      },
      { merge: true }
    )
    .then(() => {
      history.push(`/workouts/${workoutId}`);
      return dispatch({ type: ASSIGN_CLIENTS_SUCCEED });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: ASSIGN_CLIENTS_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const renameWorkout = (name, workoutId, history) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(WORKOUTS).doc(workoutId);

  //checkNameUniqueness = (value, collection, field)
  return checkUniqueness(name, WORKOUTS, 'name')
    .then(isUnique => {
      if (isUnique) {
        dispatch({ type: SUBMITTIG_LOADING_STATE });
        return docRef
          .update('name', name)
          .then(() => {
            history.push(`/workouts/${workoutId}`);
            return dispatch({ type: RENAME_WORKOUT_SUCCEED });
          })
          .catch(function(error) {
            console.log(error);
            dispatch({
              type: RENAME_WORKOUT_ERROR,
              payload: `error: ${error}`
            });
          });
      } else {
        dispatch({
          type: WORKOUT_UNIQUENESS_CHECK_ERROR,
          payload: WORKOUT_NAME_MUST_BE_UNIQUE
        });
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: RENAME_WORKOUT_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getExercies = () => async dispatch => {
  let getExercies = firebase.functions().httpsCallable('dbExercisesGetAllForTrainer');
  return getExercies().then(result => {
      result.data.sort((ex1, ex2) => {
        return (
          (ex1.name > ex2.name ? 1 : -1)
        );
      });

      dispatch({
        type: GET_TRAINER_EXERCIES_SUCCEED,
        payload: result.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_TRAINER_EXERCIES_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getReps = () => async dispatch => {
  try {
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(REPS);
    return queryRef.onSnapshot(querySnapshot => {
      const reps =
        querySnapshot.docs &&
        querySnapshot.docs.map(doc => {
          return {
            ...doc.data(),
            id: doc.id
          };
        });
      dispatch({ type: GET_REPS_SUCCEED, payload: reps });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_REPS_ERROR,
      payload: `error: ${err}`
    });
  }
};

export const createSeries = (values, workoutId, history) => async dispatch => {
  try {
    let queryRef =
      firebase.firestore()
      .collection(`workouts/${workoutId}/workout_series`)
      .where('name', '==', values.seriesName);
    return queryRef.get().then(querySnapshot => {
      if(querySnapshot.empty){ //unique
        dispatch({
          type: SUBMITTIG_LOADING_STATE
        });
        let { seriesName, sets, reps, repsType, method, ExerciesList } = values;
        ExerciesList = ExerciesList.filter(exercise =>  exercise && exercise.exercise_id);
        let newSeries = {
          name: seriesName,
          sets: ~~sets,
          is_custom_reps: repsType === CUSTOM_REP,
          exercises: ExerciesList.map(exercise => exercise.exercise_name)
        };

        if (repsType === CUSTOM_REP) {
          newSeries['reps'] = ~~reps;
        } else if (repsType === METHOD) {
          newSeries['method'] = method;
        }

        return firebase.firestore()
          .collection(`workouts/${workoutId}/workout_series`)
          .add({...newSeries})
          .then(function(docRef) {
            let batch = firebase.firestore().batch();

            ExerciesList.forEach(exercise => {
              if(!!exercise && exercise.exercise_id){
                let { exercise_id, exercise_name, weight, tempo, rest } = exercise;
                let seriesRef =
                  firebase.firestore()
                  .collection(`workouts/${workoutId}/workout_series/${docRef.id}/workout_exercises`)
                  .doc();
                batch.set(
                  seriesRef,
                  {
                    exercise_id: exercise_id,
                    exercise_name: exercise_name,
                    weight: ~~weight,
                    tempo: ~~tempo,
                    rest: ~~rest,
                    rest_unit: 'secs'
                  },
                  { merge: true }
                );
              }
            });
            return batch
              .commit()
              .then(function() {
                history.push(`/workouts/${workoutId}`);
                return dispatch({
                  type: CREATE_SERIES_SUCCEED
                });
              })
              .catch(function(error) {
                console.log(error);
                dispatch({
                  type: CREATE_SERIES_ERROR,
                  payload: `error: ${error}`
                });
              });
          })
          .catch(function(error) {
            console.error(error);
            dispatch({
              type: CREATE_WORKOUT_ERROR,
              payload: `error: ${error}`
            });
          });
      } else { // not unique
        dispatch({
          type:  CREATE_SERIES_UNIQUENESS_ERROR,
          payload: SERIES_NAME_MUST_BE_UNIQUE
        });
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type:  CREATE_SERIES_ERROR,
      payload: `error: ${err}`
    });
  }
};

export const getSeriesById = (workoutId, seriesId, history) => async dispatch => {
  let firestore = firebase.firestore();
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      dispatch({ type: SERIES_LOADING_STATE });
      let docRef = firestore.collection(`/workouts/${workoutId}/workout_series`).doc(seriesId);
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            getSeriesExercises(workoutId, { ...doc.data(), id: doc.id }, dispatch);
          } else {
            history.replace('/event-not-found');
            console.log('This Seris is not exist!');
          }
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: GET_SERIES_BY_ID_ERROR,
            payload: `error: ${error}`
          });
        });
    } else {
      throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
    }
  });
};

const getSeriesExercises = (workoutId, series, dispatch) => {
  let firestore = firebase.firestore();
  firestore
    .collection(`workouts/${workoutId}/workout_series/${series.id}/workout_exercises`)
    .get()
    .then(querySnapshot => {
      const exercises =
        querySnapshot.docs &&
        querySnapshot.docs.map(exerciseDoc => {
          return { ...exerciseDoc.data(), id: exerciseDoc.id };
        });
      dispatch({
        type: GET_SERIES_BY_ID_SUCCEED,
        payload: { ...series, exerciseCollection: exercises }
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_SERIES_BY_ID_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getWorkoutWithioutSubs = (workoutId, history) => async dispatch => {
  let firestore = firebase.firestore();
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      let docRef = firestore.collection(WORKOUTS).doc(workoutId);
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            dispatch({
              type: GET_WORKOUT_SUCCEED,
              payload: { ...doc.data(), id: doc.id }
            });
          } else {
            history.replace('/event-not-found');
            console.log('This Workout is not exist!');
          }
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: GET_WORKOUT_ERROR,
            payload: `error: ${error}`
          });
        });
    } else {
      throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
    }
  });
};

export const deleteSeries = (workoutId, seriesId, history) => async dispatch => {
  let db = firebase.firestore();
  db.collection(`workouts/${workoutId}/workout_series`)
    .doc(seriesId)
    .delete()
    .then(function() {
      console.log('Document successfully deleted!');
      history.push(`/workouts/${workoutId}`);
    })
    .catch(function(error) {
      console.error('Error removing document: ', error);
      dispatch({
        type: DELETE_SERIES_ERROR,
        payload: `error: ${error}`
      });
    });
}

export const editSeries = (values, workoutId, history) => async dispatch => {
  try {
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(`workouts/${workoutId}/workout_series`)
      .where('name', '==', values.seriesName);
    return queryRef.get().then(querySnapshot => {
      const series =
        querySnapshot.docs &&
        querySnapshot.docs.map(seriesDoc => {
          return { ...seriesDoc.data(), id: seriesDoc.id };
        });
      if(querySnapshot.empty || (series.length === 1 && series[0].id === values.id)){ //unique
        dispatch({
          type: SUBMITTIG_LOADING_STATE
        });
        let { seriesName, sets, reps, repsType, method, ExerciesList, deletedExercies } = values;
        ExerciesList = ExerciesList.filter(exercise =>  exercise && exercise.exercise_id);
        let newSeries = {
          name: seriesName,
          sets: ~~sets,
          reps: repsType === CUSTOM_REP ? ~~reps : '',
          method: repsType === METHOD ? method : '',
          is_custom_reps: repsType === CUSTOM_REP,
          exercises: ExerciesList.map(exercise => exercise.exercise_name)
        };

        let Ref = firebase.firestore()
          .collection(`workouts/${workoutId}/workout_series`)
          .doc(values.id);

        Ref.set({...newSeries}, { merge: true })
          .then(() => {
            let batch = firestore.batch();

            (deletedExercies || []).forEach(exerciseId => {
              let seriesRef =
                    firestore
                    .collection(`workouts/${workoutId}/workout_series/${values.id}/workout_exercises`)
                    .doc(exerciseId);
              batch.delete(seriesRef);
            });

            ExerciesList.forEach(exercise => {
              if(!!exercise && exercise.exercise_id){
                let { id, exercise_id, exercise_name, weight, tempo, rest } = exercise;
                let seriesRef = null;
                if(id){
                  seriesRef =
                    firestore
                    .collection(`workouts/${workoutId}/workout_series/${values.id}/workout_exercises`)
                    .doc(id);
                } else {
                  seriesRef =
                    firestore
                    .collection(`workouts/${workoutId}/workout_series/${values.id}/workout_exercises`)
                    .doc();
                }

                batch.set(
                  seriesRef,
                  {
                    exercise_id: exercise_id,
                    exercise_name: exercise_name,
                    weight: ~~weight,
                    tempo: ~~tempo,
                    rest: ~~rest,
                    rest_unit: 'secs'
                  },
                  { merge: true }
                );
              }
            });
            batch
              .commit()
              .then(function() {
                dispatch({
                  type: EDIT_SERIES_SUCCEED
                });
                history.push(`/workouts/${workoutId}/series/${values.id}`);
              })
              .catch(function(error) {
                console.log(error);
                dispatch({
                  type: EDIT_SERIES_ERROR,
                  payload: `error: ${error}`
                });
              });
          })
          .catch(function(error) {
            console.error('Error adding document: ', error);
            dispatch({
              type: EDIT_SERIES_ERROR,
              payload: `error: ${error}`
            });
          });
      } else { // not unique
        dispatch({
          type:  CREATE_SERIES_UNIQUENESS_ERROR,
          payload: SERIES_NAME_MUST_BE_UNIQUE
        });
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type:  EDIT_SERIES_ERROR,
      payload: `error: ${err}`
    });
  }
};

export const resetExerciseModel = () => async dispatch => {
  dispatch({ type: RESET_EXERCISE_MODEL });
};

export const createExercise = (values, setModalOpen) => async dispatch => {
  let firestore = firebase.firestore();
  var trainer = await firebase.auth().currentUser;

  let queryRef = firestore
      .collection(EXERCISES)
      .where('name', '==', values.name);
    return queryRef.get().then(querySnapshot => {
      if (querySnapshot.empty) {
        return firestore
          .collection(EXERCISES)
          .add({ ...values, trainer_id: trainer.uid })
          .then(function(docRef) {
            dispatch({
              type: CREATE_EXERCISE_SUCCEED,
              payload: { ...values, trainer_id: trainer.uid, id: docRef.id }
            });
          })
          .catch(function(error) {
            console.error('Error adding document: ', error);
            dispatch({
              type: CREATE_EXERCISE_ERROR,
              payload: `error: ${error}`
            });
          });
      } else {
        dispatch({
          type: EXERCISE_UNIQUENESS_CHECK_ERROR,
          payload: EXERCISE_UNIQUENESS_ERROR
        });
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: CREATE_EXERCISE_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getClientWorkouts = clientId => async dispatch => {
  try {
    let firestore = firebase.firestore();

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch({
          type: LOADING_STATE
        });
        let queryRef = firestore
          .collection(WORKOUTS)
          .where('trainer_id', '==', user.uid)
          .where('clients_id', 'array-contains', clientId);
        return queryRef.get().then(Response => {
          const workouts =
            Response.docs &&
            Response.docs.map(doc => {
              return {
                ...doc.data(),
                id: doc.id
              };
            });
          dispatch({
            type: GET_CLIENT_WORKOUT_SUCCEEDED,
            payload: {
              workouts: workouts
            }
          });
        });
      } else {
        throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_CLIENT_WORKOUT_ERROR,
      payload: `error: ${err}`
    });
  }
};

export const assignClientToWorkouts = (client, workoutsIds, history) => async dispatch => {
  let firestore = firebase.firestore();
  var batch = firestore.batch();
  const assignDate = new Date();

  workoutsIds.forEach(workoutId => {
    let workoutDocRef = firestore.collection(WORKOUTS).doc(workoutId);
    batch.set(
      workoutDocRef,
      {
        clients_id: firebase.firestore.FieldValue.arrayUnion(client.id),
        clients_data: {
          [`${client.id}`]: {
            assigned_at: assignDate,
            photo_url: client.photo || '',
            display_name: `${client.first_name} ${client.last_name}`
          }
        }
      },
      { merge: true }
    );
  });

  return batch
    .commit()
    .then(function() {
      dispatch({
        type: ASSIGN_CLIENT_TO_WORKOUTS_SUCCEEDED
      });
      history.push(`/clients/${client.id}?tab=workout`);
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: ASSIGN_CLIENT_TO_WORKOUTS_ERROR,
        payload: `error: ${error}`
      });
    });
}